var _path, _path2, _path3, _path4, _path5, _path6, _line, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DatabaseExport50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M28,11.06c-8.28,0-15,2.17-15,4.84c0,0,0,24.12,0,24.19c0,2.67,6.72,4.84,15,4.84s15-2.17,15-4.84 c0-0.07,0-24.19,0-24.19C43,13.23,36.28,11.06,28,11.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M34,7.68c3.36,0.92,5.5,2.29,5.5,3.82c0,2.76-6.94,5-15.5,5s-15.5-2.24-15.5-5s6.94-5,15.5-5 c0.27,0,0.55,0,0.82,0.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M39.5,17.07c0-3.24,0-5.57,0-5.57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8.5,11.5c0,0,0,24.93,0,25c0,2.76,6.94,5,15.5,5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M32.51,32.38C30.07,32.9,27.14,33.2,24,33.2c-8.56,0-15.5-2.24-15.5-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M33.31,23.8c-2.59,0.63-5.82,1-9.31,1c-8.56,0-15.5-2.24-15.5-5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    x2: 39.5,
    y1: 24.8,
    y2: 45.69,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "33.31,39.2 39.5,45.69 45.69,39.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DatabaseExport50);
export default __webpack_public_path__ + "static/media/icons8-database-export-50.97e614474ce887158871a08155526b41.svg";
export { ForwardRef as ReactComponent };